import AssetCardFormModal from "./AssetCardFormModal";

export const AddAssetCard = ({ refresh, setState, onAlert }) => (
  <AssetCardFormModal mode="create" refresh={refresh} setState={setState} onAlert={onAlert} />
);
